import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useHousehold } from "@/context/HouseholdContext";

export const useDashboard = () => {
  const { active } = useHousehold();
  return useQuery({
    queryKey: ["dashboard", active?.id],
    queryFn: () => api.get(`/households/${active.id}/dashboard`).then((r) => r.data),
    enabled: !!active,
  });
};
